<template>
  <div class="myteamatt">
    <toptitle :title1="titlework" />
    <div class="circle-echart">
      <div class="timeSelect">
        <section class="date-cond date-department">
          <div class="arrow-check" @click="isShowDeptPicker">
            {{ deptSearch }}
          </div>
        </section>
        <section class="date-cond">
          <div class="arrow-check" @click="isShowDatePicker">
            {{ dateSearch | datefmt }}
          </div>
        </section>
      </div>
      <echart-attendance
        :rateTotal="attendanceRate"
        :itemsData="items_dept"
      ></echart-attendance>
      <div class="remark">
        备注：出勤率=(正常出勤+出差)次数/∑考勤类型次数
      </div>
    </div>
    <!--日期选择 -->
    <van-popup v-model="showDatePicker" position="bottom">
      <van-datetime-picker
        v-model="dateSearch"
        type="year-month"
        title="选择年月"
        @confirm="datePickerConfirm"
        :min-date="dateSearchMinDate"
        :max-date="dateSearchMaxDate"
      />
    </van-popup>
    <!--部门选择-->
    <van-popup v-model="showDeptPicker" position="bottom">
      <van-picker
        v-model="deptSearch"
        show-toolbar
        title="请选择部门"
        :columns="columns2"
        @confirm="deptPickerConfirm"
      />
    </van-popup>
    <van-loading size="30px" vertical v-if="loading" style="margin-top: 10px;"
      >加载中...</van-loading
    >
    <div v-if="!loading">
      <!--请假 -->
      <div v-if="subBody.VACATION_TOTAL > 0">
        <ListLeave :subBody="subBody" />
      </div>
      <!--迟到/早退 -->
      <div v-if="subBody.ATTENDACE_TOTAL > 0">
        <ListLate :subBody="subBody" />
      </div>
      <!--缺勤 -->
      <div v-if="subBody.ABSENT_TOTAL > 0">
        <ListAbsence :subBody="subBody" />
      </div>
      <!--出差 -->
      <div v-if="subBody.BUSINESS_TOTAL > 0">
        <ListAway :subBody="subBody" />
      </div>
    </div>
  </div>
</template>

<script>
  import toptitle from '../components/toptitle';
  import {
    GetMyTeamAttDataApi,
    getMyTeamCountApi,
    getMyDeptDataApi
  } from '../request/api';

  import dateformat from '@/utils/dateformat';
  import EchartAttendance from '../components/myteamatt/echartAttendance';
  import ListAbsence from '../components/myteamatt/listabsence';
  import ListAway from '../components/myteamatt/listaway';
  import ListLate from '../components/myteamatt/listlate';
  import ListLeave from '../components/myteamatt/listleave';

  export default {
    name: 'myteamatt',
    data() {
      return {
        titlework: '考勤异常',
        activeNames: ['1'],
        loading: false,
        loadFinished: false,
        currentPageNo: 1,
        maxPageNo: 0,
        dateSearchMinDate: new Date(2021, 9, 1), //年月范围中的最小值定义
        dateSearchMaxDate: new Date(), //年月范围中可选的最大值定义，在 created 中动态设置为当前月份
        dateSearch: '',
        deptSearch: '部门',
        showDatePicker: false,
        showDeptPicker: false,
        attendanceData: [],
        attendanceRate: '',
        items_dept: [],
        department: [], //部门
        columns2: [],
        subBody: {}
      };
    },
    mounted() {
      this.getDeptList();
    },
    methods: {
      isShowDatePicker() {
        this.showDatePicker = true;
      },
      isShowDeptPicker() {
        this.showDeptPicker = true;
      },
      datePickerConfirm() {
        //更改了日期，重新获取数据
        this.showDatePicker = false;
        this.currentPageNo = 1;
        this.getList();
        this.getTeamAttAnalysis();
      },
      deptPickerConfirm(value, index) {
        this.deptSearch = value;
        this.currentPageNo = 1;
        this.showDeptPicker = false;
        this.getList();
        this.getTeamAttAnalysis();
      },
      /**
       * 部门获取
       * **/
      getDeptList() {
        let params = {
          EMPLID: sessionStorage.getItem('EMPLID')
        };
        getMyDeptDataApi(params).then(res => {
          if (res.CODE === 200) {
            this.department = res.DATA;

            this.columns2 = this.department.map(item => {
              return item.DEPT_DESCR;
            });
            if (this.deptSearch == '部门') {
              this.deptSearch = this.department[0].DEPT_DESCR;
            }
            this.getTeamAttAnalysis();
            this.getList();
          }
        });
      },

      /**
       * echarts
       *  **/
      getTeamAttAnalysis() {
        //部门ID
        let departId = '';
        let emplId = '';
        this.department.forEach(element => {
          if (this.deptSearch == element.DEPT_DESCR) {
            departId = element.DEPTID;
            emplId = element.EMPLID;
          }
        });

        let params = {
          DEPTID: departId,
          EMPLID: emplId,
          CAL_PRD: dateformat('yyyy-MM', this.dateSearch)
        };

        getMyTeamCountApi(params).then(res => {
          if (res.CODE === 200) {
            this.attendanceData = res.DATA;
            let deptArray = [];
            this.attendanceRate = this.attendanceData.RATE.toString();
            // console.log(this.attendanceData)
            deptArray.push(this.attendanceData.VACATION);
            deptArray.push(this.attendanceData.ATTENDANCE);
            deptArray.push(this.attendanceData.LATEEARLY);
            deptArray.push(this.attendanceData.ABSENT);
            deptArray.push(this.attendanceData.BUSINESS);

            this.items_dept = deptArray.map(item => {
              return {
                value: item.VALUE ? item.VALUE : '',
                name: item.NAME
              };
            });
          }
        });
      },
      getList() {
        this.loading = true;
        //部门ID
        let departId = '';
        let emplId = '';
        this.department.forEach(element => {
          if (this.deptSearch == element.DEPT_DESCR) {
            departId = element.DEPTID;
            emplId = element.EMPLID;
          }
        });
        let params = {
          DEPTID: departId,
          EMPLID: emplId,
          PAGE: this.currentPageNo.toString(),
          RECORD: 1000,
          NAME: '',
          CAL_PRD: dateformat('yyyy-MM', this.dateSearch)
        };
        GetMyTeamAttDataApi(params)
          .then(res => {
            if (res.CODE === 200) {
              this.subBody = res.DATA;
            }
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    components: {
      toptitle,
      EchartAttendance,
      ListAbsence,
      ListAway,
      ListLate,
      ListLeave
    },
    filters: {
      datefmt(val) {
        //格式化日期查询条件的显示内容

        if (!val) return '';
        return dateformat('yyyy年MM月', new Date(val));
      }
    },
    created() {
      this.showDatePicker = false;

      //能选择的最大年月为当前月份
      this.dateSearchMaxDate = new Date(dateformat('yyyy-MM-01'));

      //默认为当前月份
      this.dateSearch = new Date(dateformat('yyyy-MM-01'));
    }
  };
</script>

<style lang="less" scoped>
  .circle-echart {
    background-color: #fff;
  }
  .myPies {
    padding: 0 10px;
    box-sizing: border-box;
    // top: -40px;
    position: relative;
  }
  /deep/.van-search {
    background: #efeff4;
    margin-bottom: 10px;
    border-bottom: 1px solid #e5e5e5;
  }
  .date-cond {
    div {
      text-align: center;
      height: 40px;
      line-height: 40px;
      position: relative;
      font-size: 13px;
    }
    .arrow-check::before {
      content: '';
      width: 5px;
      height: 5px;
      border: solid #666;
      border-width: 1px 0 0 1px;
      transform: translate(-50%, -50%) rotate(-45deg);
      position: absolute;
      left: 3%;
      top: 50%;
      margin: 0px -10px;
    }
    .arrow-check::after {
      content: '';
      width: 5px;
      height: 5px;
      border: solid #666;
      border-width: 1px 0 0 1px;
      transform: translate(-50%, -50%) rotate(135deg);
      position: absolute;
      right: 0%;
      top: 50%;
      margin: 0px -10px;
    }
  }

  .date-department {
    max-width: 60%;
    height: 30px;
    padding: 0px 12px;
    overflow: hidden;
  }

  .timeSelect {
    display: flex;
    justify-content: space-between;
    width: 85%;
    margin: 0 auto;
    border-top: 1px solid #e5e5e5;
  }
  .remark {
    padding: 0 20px 10px;
    color: #909399;
    font-size: 14px;
  }
  .summary-collapse {
    margin: 10px 0px 0;

    background: white;
    border-radius: 10px;
    .col-title {
      font-size: 16px;
    }
    .clock {
      line-height: 44px;
      color: black;

      font-size: 16px;
      border-bottom: 1px dotted #aeb5c2;
      display: flex;
      justify-content: flex-start;
      span {
        display: inline-block;
        width: 40%;
        //float: right;
        font-size: 16px;
        color: #8f8f8f;
      }
    }
  }
</style>
